import {Component, Input, OnInit} from '@angular/core';
import {ConfigStructure} from "../../../config/config-structure.model";
import {AppConfigService} from "../../../config/app-config.service";
import {TranslatorService} from "../../../shared/translator.service";
import {Property} from "../../../shared/property/property.model";
import {AppUtils} from "../../../shared/app-utils";
import {Title} from '@angular/platform-browser';


@Component({
  selector: 'app-museum-object',
  templateUrl: './museum-object.component.html',
  styleUrls: ['./museum-object.component.css']
})
export class MuseumObjectComponent implements OnInit {

  museumObject;

  _externalUrl: string;

  properties: Property[];

  @Input('museumObject')
  set _museumObject(museumObject) {
    this.museumObject = museumObject;
    this.properties = AppUtils.mapObjectToProperties(this.museumObject);

    let obj: string[] = this.museumObject["mus_object_identifier"];

    if (obj) {
      this._externalUrl = obj.find(item => item.toString().startsWith("http"))
    }

  }

  constructor(private appConfig: AppConfigService, private translator: TranslatorService, private titleService: Title) {
  }

  ngOnInit(): void {
    this.properties = AppUtils.mapObjectToProperties(this.museumObject);
    if (this.getTitle() && this.getTitle().value) {
      this.titleService.setTitle('Omnis - ' + this.getTitle().value)
    }
  }

  getAuthors(): Property {
    return this.translator.find(this.properties, "mus_object_creator");
  }

  getTitle(): Property {
    return this.translator.find(this.properties, "mus_object_title");
  }

  getConfig(): ConfigStructure[] {
    return this.appConfig.museumObjectConfig.museumObjectConfig;
  }
}
